import React, { useEffect, useState } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { GetFieldTicketFormList, CheckEditFieldTicket } from '../../API/JobForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';

export default props => {
    const [fieldTickets, setFieldTickets] = useState([]);
    const [dispButton, setDispButton] = useState(false);
    useEffect(()=>{
        CheckEditFieldTicket(0)
        .then(res=>{
            setDispButton(res.success)
        })
        GetFieldTicketFormList(props.jobId, props.stepId)
        .then(res => {
            setFieldTickets(res.data)
        })
    },[props.jobId, props.stepId])
    return (
        <div className="container">
        <div className="row my-3">
            <div className="col text-center">
            {dispButton && <Button className="enc-button" as={Link} to={`${props.match.url}/new`}>Create Ticket</Button>}
            </div>
        </div>
        <ListGroup>
            <ListGroup.Item className="click-list">Field Tickets</ListGroup.Item>
            {fieldTickets.length === 0 && <ListGroup.Item>No Forms Available</ListGroup.Item>}
            {fieldTickets.map(ft => {
                return(
            <ListGroup.Item className="click-list" key={`field-ticket-${ft.fieldTicketId}`} as={Link} to={`${props.match.url}/${ft.fieldTicketId}`}>
                <div className="row">
                    <div className="col-1">
                    {ft.completed ?
                    <FontAwesomeIcon icon={faCheck} style={{ color: "green" }} />
                    :
                    <FontAwesomeIcon icon={faTimes} style={{ color: "red" }} />
                        }
                    </div>
                    <div className="col">
                        {ft.date}
                    </div>
                    <div className="col">
                        Field Ticket
                    </div>
                </div>
            </ListGroup.Item>
            )})}
        </ListGroup>
        </div>
    )
}
